export const serviceHeader = require("./service-header.jpg");
export const sofaCleaning = require("./sofa-cleaning.jpg");
export const acRepairs =  require("./acRepair.jpg");
export const banner = require("./banner.jpg");
export const logo = require("./logo.png");
export const painting = require("./painting.jpeg");
export const confirm = require("./confirm.jpg");